import { apiClient } from '@/utils/apiClient';
import type { ReplayStatus, ReplayBundleV1 } from '@arrowise/shared';

export async function getReplayStatus(sessionId: string): Promise<ReplayStatus> {
    const res = await apiClient.get<ReplayStatus>(`/sessions/${encodeURIComponent(sessionId)}/replay/status`);
    return res.data as unknown as ReplayStatus;
}

export async function getReplayBundle(sessionId: string): Promise<ReplayBundleV1> {
    const res = await apiClient.get<ReplayBundleV1>(`/sessions/${encodeURIComponent(sessionId)}/replay`);
    return res.data as unknown as ReplayBundleV1;
}

export const replayService = {
    getReplayStatus,
    getReplayBundle,
};


